'use client';

import React, { useEffect } from 'react';
import aa from 'search-insights';
import getLanguageByLocale from '../../../components/src/utils/getLanguageByLocale';
import { safeDataLayerPush } from '../../../components/src/utils/safeDataLayerPush';
import { GTMInit } from './gtm-init';

declare global {
  interface Window {
    aa?: any;
    dataLayer?: any;
  }
}

type RootLayoutClientProps = {
  children: React.ReactNode;
  locale: string;
};

export function RootLayoutClient({ children, locale }: RootLayoutClientProps) {
  // Update html lang attribute based on locale
  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.documentElement.lang = locale;
    }
  }, [locale]);

  useEffect(() => {
    if (process.env.ALGOLIA_APP_ID && process.env.ALGOLIA_SEARCH_API_KEY) {
      aa('init', {
        appId: process.env.ALGOLIA_APP_ID as string,
        apiKey: process.env.ALGOLIA_SEARCH_API_KEY as string,
        useCookie: true
      });
      aa(
        'onUserTokenChange',
        (userToken) => {
          safeDataLayerPush({
            algoliaUserToken: userToken
          });
        },
        { immediate: true }
      );
    }
  }, []);

  useEffect(() => {
    safeDataLayerPush({ localeLanguage: getLanguageByLocale(locale) });
  }, [locale]);

  return (
    <React.Fragment>
      <GTMInit />
      {children}
    </React.Fragment>
  );
}
